import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import {
  registerStoreUserOtpName,
  resendRegisterOTP,
  setToken,
  signInUser,
} from "../../actions/authActions";
import OtpInput from "react-otp-input";
import "./VerifyRegister.scss";
import RefreshIcon from "@mui/icons-material/Refresh";
import { toastMessage, zeroPad } from "../../helper";
import { useTranslation } from "react-i18next";
import { Steps } from "antd";
const VerifyRegister = (props: any) => {
  const { t, i18n } = useTranslation();
  const location = useLocation();

  const [otp, setOtp] = useState("");
  const [seconds, setSeconds] = useState(30);
  const [error, setError] = useState("");

  const [showTimer, setShowTimer] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const navigateToContacts = () => {
  //   // 👇️ navigate to /contacts
  //   navigate("/verifyaccount");
  // };
  // console.log("seconds outside",seconds);
  useEffect(() => {
    if (sessionStorage.getItem("fromApproval")) {
      sessionStorage.removeItem("fromApproval");
      navigate("/auth/login");
    }
  }, []);

  useEffect(() => {
    let myInterval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((seconds) => seconds - 1);
      }
      if (seconds <= 0) {
        // console.log("seconds 2",seconds);
        clearInterval(myInterval);
        setShowTimer(false);
        setSeconds(30);
      }
    }, 1000);
    return () => {
      // setSeconds(30);
      clearInterval(myInterval);
    };
  });
  const user = useSelector((state: any) => state.auth);

  const resendOTP = () => {
    setSeconds(30);
    setShowTimer(true);
    resendRegisterOTP(user.username, false)
      .then((res) => {
        toastMessage("OTP Resent To Mail", "info");
      })
      .catch((err) => {
        toastMessage(err?.response?.data?.message, "error");

        console.log(
          "Error:",
          err.response && err.response.data && err.response.data.message
        );
      });
    // resendOTPAction()
    // setRestart(()=> !restart);
  };
  const userName = localStorage.getItem("userName");
  const onChange = async (value: string) => {
    // const re = /^[0-9\b]+$/;
    // if (value === "" || re.test(value)) {
    //   setOtp(value);
    // }
    setOtp(value);
    if (value.length === 6) {
      try {
        const userName = localStorage.getItem("userName") || "";
        const res = await registerStoreUserOtpName(userName, value, "", false);
        console.log("res ", res);
        if (res.data) {
          toastMessage("Company Registration Successfully", "success");
          setError("");
          console.log("res.data", res.data);
          signInUser(
            userName,
            location.state.password,
            "registration",
            localStorage.getItem("accountType") || ""
          )
            .then((res: any) => {
              dispatch(setToken(res.data.token));
              navigate(
                res.data.redirectToPending
                  ? "/coorporate-onboarding"
                  : "/organisation/facility"
              );
            })
            .catch((err) => {
              toastMessage(err?.response?.data?.message, "error");

              console.log(
                "Error:",
                err.response && err.response.data && err.response.data.message
              );
            });
        }
      } catch (e) {
        setError("Incorrect/Invalid OTP");
        console.log("errr", e);
      }
    }
  };

  return (
    <div className="flex">
      <div className="flex flex-col w-30v pw-height-100v pw-side-verify bg-neutral-800">
        <img
          className="h-10v object-contain mb-8"
          src="assets/images/logo.png"
          alt=" "
        />
        <Steps
          direction="vertical"
          current={0}
          className="pw-steps"
          size={"small"}
          items={[
            {
              title: "OTP Verification",
            },
            {
              title: "Status",
            },
          ]}
        />
      </div>
      <div className="flex flex-col w-70v pw-padding-4 pw-height-100v pw-overflow-y-auto">
        <div className="pw-tab-label">
          {t("Welcome")} {userName ? userName.split("@")[0] : "Admin"}
        </div>
        <div className="pw-description">{t("OTP sent")}</div>
        <div className="pw-title">{t("Enter OTP")}</div>
        <OtpInput
          value={otp}
          onChange={onChange}
          numInputs={6}
          isInputNum={true}
          className={` ${error ? "pw-error-border" : "pw-border"} `}
          separator={<span>&nbsp;</span>}
        />
        <div
          className={
            `pw-error ` + error ? "pw-display-error" : "pw-display-none"
          }
        >
          {error}
        </div>
        <div className="pw-resend-otp pw-width-100 flex flex-row">
          <div
            className={`pw-resend-text flex flex-row ${
              !showTimer
                ? "pw-cursor-pointer "
                : "cursor-not-allowed opacity-50"
            }`}
            onClick={!showTimer ? resendOTP : () => {}}
          >
            <div className={` ${showTimer ? "" : "pw-primary-color"}`}>
              <RefreshIcon sx={{ fontSize: "18px" }} />
              <span> {t("Resend OTP")}</span>
            </div>
          </div>

          <div className={` ${showTimer ? "" : "pw-display-none"}`}>
            00:
            {zeroPad(seconds, 2)}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VerifyRegister;
